'use client';

import { createContext } from 'react';
import type { TourContextValue } from '../types';

/**
 * Shared TourContext — consumed by useTour(), provided by TourProvider.
 */
export const TourContext = createContext<TourContextValue | null>(null);
